import { render, staticRenderFns } from "./StartPageHero.vue?vue&type=template&id=94a5ee0e"
import script from "./StartPageHero.vue?vue&type=script&lang=js"
export * from "./StartPageHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports